import { useSelector } from 'react-redux';
import { PropertySettingType } from '@common/entities';
import { RootState } from 'state/store';

export function usePropertySettingEnabled(settingType: PropertySettingType): boolean {
  const propertySettings = useSelector(
    (state: RootState) => state.propertySettings.propertySettings,
  );

  return propertySettings.some(
    (setting) => setting.settingType === settingType && setting.value === true,
  );
}
